import React from "react";
import aboutcontent from "../../images/about/about-content.svg";

const AboutContent = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between align-items-center">
          <div className="col-lg-6">
            <div className="px-4">
              <img src={aboutcontent} alt="About" />
            </div>
          </div>
          <div className="col-lg-6 d-lg-flex flex-lg-column gap-3">
            <h2 className="heading_text text-dark text-start mb-0">About TopCoin UK</h2>
            <p className="info_description opacity-50 text-dark mb-0">
              TopCoin UK Ltd is a UK-based advertising, customer loyalty and rewards platform.
            </p>
            <p className="info_description opacity-50 text-dark mb-0">
              We connect customers with participating companies, shops and retailers while helping make qualifying everyday purchases more rewarding.
            </p>
            <p className="info_description opacity-50 text-dark mb-0">
              Our aim is simple: <strong>help businesses connect with customers while giving customers the opportunity to receive additional loyalty rewards through their everyday shopping.</strong>
            </p>

            <h3 className="heading_text text-dark text-start mb-0 mt-4 fs-4">How TopCoin Works</h3>
            <p className="info_description opacity-50 text-dark mb-0">
              Customers may receive <strong>TopCoin</strong> when they make qualifying purchases or participate in eligible promotions through participating companies, shops and retailers.
            </p>
            <p className="info_description opacity-50 text-dark mb-0">
              Qualifying TopCoin is recorded in the customer's <strong>TopCoin Wallet</strong>.
            </p>
            <p className="info_description opacity-50 text-dark mb-0">
              TopCoin is a <strong>digital loyalty and reward unit</strong> used within the TopCoin UK platform.
            </p>
            <p className="info_description opacity-50 text-dark mb-0">
              TopCoin is not cash, a cryptocurrency or an investment, and it cannot be withdrawn as cash.
            </p>

            <h3 className="heading_text text-dark text-start mb-0 mt-4 fs-4">Captain TC Rewards</h3>
            <p className="info_description opacity-50 text-dark mb-0">
              Customers with a valid and active <strong>Captain TC Rewards Card</strong> can participate in the Captain TC Rewards Programme.
            </p>
            <p className="info_description opacity-50 text-dark mb-0">
              Qualifying Captain TC Rewards TopCoin is recorded in the customer's <strong>Captain TC Rewards Wallet</strong> and contributes towards applicable Captain TC rewards, subject to the Captain TC Rewards Programme Terms & Conditions.
            </p>
          </div>
        </div>

        <div className="row mt-5">
          <div className="col-lg-12 d-lg-flex flex-lg-column gap-3">
            <h3 className="heading_text text-dark text-start mb-0 fs-4">Our Rewards</h3>
            <p className="info_description opacity-50 text-dark mb-0">
              Qualifying rewards are <strong>provided by TopCoin UK Ltd</strong>.
            </p>
            <p className="info_description opacity-50 text-dark mb-0">
              Depending on the applicable programme or promotion, rewards may include:
            </p>
            <ul className="info_description opacity-50 text-dark mb-0 ms-4" style={{ listStyleType: "disc" }}>
              <li>Physical gold</li>
              <li>Gift cards and eGift cards</li>
              <li>Vouchers</li>
              <li>Products</li>
              <li>Promotional benefits</li>
              <li>Other non-cash rewards offered by TopCoin UK Ltd</li>
            </ul>
            <p className="info_description opacity-50 text-dark mb-0">
              Physical gold provided through the programme is a <strong>loyalty reward and not a cash reward</strong>.
            </p>
            <p className="info_description opacity-50 text-dark mb-0">
              TopCoin itself cannot be exchanged or withdrawn as cash.
            </p>
            <p className="info_description opacity-50 text-dark mb-0">
              All rewards are subject to the applicable eligibility requirements and programme Terms & Conditions.
            </p>

            <h3 className="heading_text text-dark text-start mb-0 mt-4 fs-4">For Customers</h3>
            <p className="info_description opacity-50 text-dark mb-0">
              TopCoin UK is designed to make qualifying everyday shopping more rewarding.
            </p>
            <p className="info_description opacity-50 text-dark mb-0">
              Instead of simply completing a purchase and receiving the product or service, customers may also receive qualifying TopCoin and have the opportunity to progress towards rewards through the TopCoin UK and Captain TC programmes.
            </p>

            <h3 className="heading_text text-dark text-start mb-0 mt-4 fs-4">For Participating Businesses</h3>
            <p className="info_description opacity-50 text-dark mb-0">
              TopCoin UK provides companies, shops and retailers with a way to promote their products and services, engage customers and support long-term customer loyalty.
            </p>
            <p className="info_description opacity-50 text-dark mb-0">
              When customers shop with participating businesses, the aim is to create benefits for both sides: <strong>businesses gain customer engagement and promotional exposure, while customers can receive qualifying TopCoin and progress towards rewards.</strong>
            </p>

            <h3 className="heading_text text-dark text-start mb-0 mt-4 fs-4">Our Purpose</h3>
            <p className="info_description opacity-50 text-dark mb-0">
              TopCoin UK is built around <strong>everyday shopping, customer loyalty and promotional rewards</strong>.
            </p>
            <p className="info_description opacity-50 text-dark mb-0">
              Whether you are a customer looking to make your qualifying purchases more rewarding or a business looking for new ways to engage customers, TopCoin UK provides a structured loyalty and promotional rewards platform.
            </p>

            <div className="mt-5 text-center p-4 rounded shadow-sm" style={{ backgroundColor: "#011957" }}>
              <h4 className="heading_text  mb-3 fs-5">Shop - Earn TopCoin - Enjoy Rewards</h4>
              <p className="info_description opacity-75  mb-2 fw-bold">TopCoin UK Ltd</p>
              <p className="info_description opacity-75  mb-0 fw-bold">Transparency - Trust - Loyalty Rewards</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutContent;
